import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notification, {showToast,} from "../../../components/common/notification/Notification";
import { Link, useNavigate, useParams } from "react-router-dom";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import AdminHeader from "../../common/Header";
import axios from "axios";
import { useSelector } from "react-redux";
import SubscriptionPlanForm from "./SubscriptionPlanForm";

const EditSubscription = () => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const editSubscriptionPlan = Api({
    url: `api/subscription/plan/editPlan`,
  });

  const getSubscriptionDetaiils = Api({
    url: `api/subscription/plan/details/${Id}`,
  });
 
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
 
  const [formData, setFormData] = useState({});
  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const response = await getSubscriptionDetaiils.fetchDataBySingleId(true);
        console.log(response)
        if (response?.data?.statusType === "SUCCESS") {
          const postData = response.data.subscriptionPlan;

          setFormData(postData);
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  }, []);

const handleSubmit = async (formData) => {
  if (!token) {
    showToast("Unauthorized. Please login again.", { type: "error" });
    return;
  }

  try {
    setIsLoading(true);
    const response = await axios.post(
      // `${baseUrl}/api/subscription/plan/editPlan`,
      `https://www.allhomedesire.in/api/subscription/plan/editPlan`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      }
    );

    const responseData = response.data;
    console.log("API DATA:", responseData);

    if (responseData.statusType === "SUCCESS") {
      showToast("Subscription plans updated successfully", { type: "success" });
      setTimeout(() => navigate("/subscription-plans"), 3000);
    } else {
      showToast("Update failed", { type: "error" });
    }

  } catch (error) {
    console.error(error.response?.data || error.message);
    showToast("Error occurred", { type: "error" });
  } finally {
    setIsLoading(false);
  }
};


  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "subscription-plans", link: "/subscription-plans" },
    { label: "Edit subscription-plans", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={3} md={4} sm={12}>
            <AdminHeader />
          </Col>
          <Col lg={9} md={8} sm={12}>
            <SingleDetailHeader
              header="Edit subscription-plans Details"
              description="Edit subscription-plans details section"
            />
            <SubscriptionPlanForm
              initialData={formData}
              onSubmit={handleSubmit}
              loading={isLoading}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditSubscription;
